import { createSlice } from "@reduxjs/toolkit";
import { bonusPointsSettingsReducer } from "../extraReducers/bounsPointsSettingsReducer";


// 定义初始化数据
const initialState = {
    getBounsPointerSettingsConfig: {} as any,
    changeBounsPointerSettingsConfig: {} as any,
};

const bonusPointsSettingsSlice = createSlice({
    name: "bonusPointsSettings",
    initialState,
    reducers: {},
    extraReducers: bonusPointsSettingsReducer,
});

// 默认导出,到处的文件需要在store入口文件引入
export default bonusPointsSettingsSlice.reducer;
